import Token from "./Token";
const ADMINTOKEN = "admin_token"

class MPToken extends Token{
    getToken(){
        return super.getToken(ADMINTOKEN)
    }
    setToken(val){
        return super.setToken(ADMINTOKEN, val);
    }
}

export default MPToken;


// WEBPACK FOOTER //
// ./src/common/AdminToken.js